import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AdministratorInCamelCase, AdministratorsQueryParams, PagedResponse } from 'mbs-ui-shared@models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdministratorService {
  private baseHref = '/api/administrators';

  constructor(private http: HttpClient) {}

  public get(params?: AdministratorsQueryParams): Observable<PagedResponse<AdministratorInCamelCase>> {
    return this.http.get<PagedResponse<AdministratorInCamelCase>>(this.baseHref, { params });
  }

  public getById(id: string): Observable<AdministratorInCamelCase> {
    return this.http.get<AdministratorInCamelCase>(`${this.baseHref}/${id}`);
  }

  public createAdministrator(admin: AdministratorInCamelCase): Observable<AdministratorInCamelCase> {
    return this.http.post<AdministratorInCamelCase>(this.baseHref, admin);
  }

  public updateAdministrator(admin: AdministratorInCamelCase): Observable<AdministratorInCamelCase> {
    return this.http.put<AdministratorInCamelCase>(`${this.baseHref}/${admin.id}`, admin);
  }

  public deleteAdministrator(id: string): Observable<null> {
    return this.http.delete<null>(`${this.baseHref}/${id}`);
  }

  public fetchValidateEmail(email: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseHref}/administrator-exists`, { params: { email } });
  }

  public isTFACanDisabled(id: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseHref}/${id}/two-factor-auth`);
  }

  public checkForDeepInstAccount(id: string): Observable<any> {
    return this.http.get<any>(`${this.baseHref}/${id}/deepinstinct`);
  }

  public createDeepInstinctAccount(id: string): Observable<{ email: string; password: string }> {
    return this.http.post<{ email: string; password: string }>(`${this.baseHref}/${id}/deepinstinct`, '');
  }
}
